import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getPaquetes = async () => {
    try {
        const response = await api.get(`${urlApi}/maintenance/getPaquetes`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const getConceptos = async () => {
    try {
        const response = await api.get(`${urlApi}/maintenance/getConceptos`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const getServicios = async () => {
    try {
        const response = await api.get(`${urlApi}/maintenance/getServicios`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const getTipoUnidad = async () => {
    try {
        const response = await api.get(`${urlApi}/input/getTipoUnidad`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const updateConcepto = async (form) => {
    try {
        const response = await api.put(`${urlApi}/maintenance/updateConcepto`,form);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const updateServicio = async (form) => {
    try {
        const response = await api.put(`${urlApi}/maintenance/updateServicio`,form);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const crearConcepto = async (form) => {
    try {
        const response = await api.post(`${urlApi}/maintenance/crearConcepto`,form);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}
export const crearServicio = async (form) => {
    try {
        const response = await api.post(`${urlApi}/maintenance/crearServicio`,form);
        return response.data;
    } catch (error) {
        console.error("Error al obtener los paquetes:", error);
        throw error;
    }
}